import { useState } from 'react';
import { Outlet, Link, useLocation } from 'react-router-dom';
import { ROUTES } from '../constants/routes';
import { Footer } from '../../components/navigation/Footer';
import logo from '/maxcash.png';

const navItems = [
  { label: 'Home', path: ROUTES.HOME },
  { label: 'About', path: ROUTES.ABOUT },
  { label: 'Services', path: '/services' },
  { label: 'Loan Products', path: ROUTES.LOAN_PRODUCTS },
  { label: 'Loan Calculator', path: '/loan-calculator' },
  { label: 'FAQ', path: ROUTES.FAQ },
  { label: 'Contact', path: ROUTES.CONTACT },
];

export const PublicLayout = () => {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const isActive = (path: string) => location.pathname === path;

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <nav className="border-b border-gray-200 bg-white sticky top-0 z-50 flex-shrink-0">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16 items-center">
            <Link to={ROUTES.HOME} className="flex items-center gap-2">
              <img src={logo} alt="MaxCash" className="h-8 w-auto" />
              <span className="text-xl font-bold text-primary-600">MaxCash</span>
            </Link>

            <div className="hidden md:flex items-center gap-4 lg:gap-6">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`text-sm transition-colors ${
                    isActive(item.path)
                      ? 'text-primary-600 font-medium'
                      : 'text-gray-600 hover:text-gray-900'
                  }`}
                >
                  {item.label}
                </Link>
              ))}
              <Link to="/apply" className="btn-primary text-sm px-4 py-2">
                Apply Now
              </Link>
              <Link to="/login" className="btn-secondary text-sm px-4 py-2">
                Login
              </Link>
              <Link to="/register" className="btn-secondary text-sm px-4 py-2">
                Register
              </Link>
            </div>

            <button
              className="md:hidden p-2 rounded-lg hover:bg-gray-100"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              {mobileMenuOpen ? '✕' : '☰'}
            </button>
          </div>
        </div>

        {mobileMenuOpen && (
          <div className="md:hidden border-t border-gray-200 bg-white">
            <div className="px-4 py-3 space-y-2">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`block px-3 py-2 rounded-lg text-sm ${
                    isActive(item.path)
                      ? 'bg-primary-50 text-primary-600 font-medium'
                      : 'text-gray-600 hover:bg-gray-50'
                  }`}
                  onClick={() => setMobileMenuOpen(false)}
                >
                  {item.label}
                </Link>
              ))}
              <Link
                to="/apply"
                className="block px-3 py-2 rounded-lg text-sm bg-primary-600 text-white text-center"
                onClick={() => setMobileMenuOpen(false)}
              >
                Apply Now
              </Link>
              <Link
                to="/login"
                className="block px-3 py-2 rounded-lg text-sm border border-gray-300 text-center"
                onClick={() => setMobileMenuOpen(false)}
              >
                Login
              </Link>
              <Link
                to="/register"
                className="block px-3 py-2 rounded-lg text-sm border border-gray-300 text-center"
                onClick={() => setMobileMenuOpen(false)}
              >
                Register
              </Link>
            </div>
          </div>
        )}
      </nav>

      <main className="flex-1">
        <Outlet />
      </main>

      <Footer />
    </div>
  );
};


// import { useState } from 'react';
// import { Outlet, Link, useLocation } from 'react-router-dom';
// import { ROUTES } from '../constants/routes';
// import { Footer } from '../../components/navigation/Footer';
// import logo from '/maxcash.png';

// const navItems = [
//   { label: 'Home', path: ROUTES.HOME },
//   { label: 'About', path: ROUTES.ABOUT },
//   { label: 'Services', path: '/services' },
//   { label: 'Loan Products', path: ROUTES.LOAN_PRODUCTS },
//   { label: 'Loan Calculator', path: '/loan-calculator' },
//   { label: 'FAQ', path: ROUTES.FAQ },
//   { label: 'Contact', path: ROUTES.CONTACT },
// ];

// export const PublicLayout = () => {
//   const location = useLocation();
//   const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

//   const isActive = (path: string) => location.pathname === path;

//   return (
//     <div className="min-h-screen bg-white flex flex-col">
//       <nav className="border-b border-gray-200 bg-white sticky top-0 z-50 flex-shrink-0">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="flex justify-between h-16 items-center">
//             <Link to={ROUTES.HOME} className="flex items-center gap-2">
//               <img src={logo} alt="MaxCash" className="h-8 w-auto" />
//               <span className="text-xl font-bold text-primary-600">MaxCash</span>
//             </Link>

//             <div className="hidden md:flex items-center gap-4 lg:gap-6">
//               {navItems.map((item) => (
//                 <Link
//                   key={item.path}
//                   to={item.path}
//                   className={`text-sm transition-colors ${
//                     isActive(item.path)
//                       ? 'text-primary-600 font-medium'
//                       : 'text-gray-600 hover:text-gray-900'
//                   }`}
//                 >
//                   {item.label}
//                 </Link>
//               ))}
//               <Link to="/apply" className="btn-primary text-sm px-4 py-2">
//                 Apply Now
//               </Link>
//               <Link to="/login" className="btn-secondary text-sm px-4 py-2">
//                 Login
//               </Link>
//               <Link to="/register" className="btn-secondary text-sm px-4 py-2">
//                 Register
//               </Link>
//             </div>

//             <button
//               className="md:hidden p-2 rounded-lg hover:bg-gray-100"
//               onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
//             >
//               {mobileMenuOpen ? '✕' : '☰'}
//             </button>
//           </div>
//         </div>

//         {mobileMenuOpen && (
//           <div className="md:hidden border-t border-gray-200 bg-white">
//             <div className="px-4 py-3 space-y-2">
//               {navItems.map((item) => (
//                 <Link
//                   key={item.path}
//                   to={item.path}
//                   className={`block px-3 py-2 rounded-lg text-sm ${
//                     isActive(item.path)
//                       ? 'bg-primary-50 text-primary-600 font-medium'
//                       : 'text-gray-600 hover:bg-gray-50'
//                   }`}
//                   onClick={() => setMobileMenuOpen(false)}
//                 >
//                   {item.label}
//                 </Link>
//               ))}
//               <Link
//                 to="/apply"
//                 className="block px-3 py-2 rounded-lg text-sm bg-primary-600 text-white text-center"
//                 onClick={() => setMobileMenuOpen(false)}
//               >
//                 Apply Now
//               </Link>
//               <Link
//                 to="/login"
//                 className="block px-3 py-2 rounded-lg text-sm border border-gray-300 text-center"
//                 onClick={() => setMobileMenuOpen(false)}
//               >
//                 Login
//               </Link>
//               <Link
//                 to="/register"
//                 className="block px-3 py-2 rounded-lg text-sm border border-gray-300 text-center"
//                 onClick={() => setMobileMenuOpen(false)}
//               >
//                 Register
//               </Link>
//             </div>
//           </div>
//         )}
//       </nav>

//       <main className="flex-1">
//         <Outlet />
//       </main>

//       <Footer />
//     </div>
//   );
// };
